import { Input } from "antd";
import Form, { Rule } from "antd/es/form";

const { Item: FormItem } = Form;

interface TextInputProps {
  label: string;
  name: string;
  rules?: Rule[];
  className?: string;
}

export default function TextInput({
  label,
  name,
  rules,
  className,
}: TextInputProps) {
  return (
    <FormItem label={label} name={name} rules={rules} className={className}>
      <Input />
    </FormItem>
  );
}
